var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-spinner"},[_c('i',{staticClass:"el-icon-loading"})])])
}]

export { render, staticRenderFns }